import React from 'react';

import MainWrapper from './MainWrapper';

const AccreditationQuestionnaire = () => {
  return <MainWrapper />;
};

export default AccreditationQuestionnaire;
